import { UpdatePurchaseOrderInvoiceFormData, PatchPurchaseOrderInvoiceRequestBody, PurchaseOrder } from "src/types";

export class UpdatePurchaseOrderInvoiceMapper {
  public static initUpdatePurchaseOrderInvoiceFormData(): UpdatePurchaseOrderInvoiceFormData {
    return {
      purchaseOrderId: "",
      invoiceDueDate: "",
      additionalInfo: "",
      invoiceFiles: [],
      isProforma: false,
      invoiceReferenceNumber: ""
    };
  }

  public static updatePurchaseOrderInvoiceFormDataFromPurchaseOrder(
    purchaseOrder: PurchaseOrder,
    purchaseOrderInvoiceFiles: File[] = []
  ): UpdatePurchaseOrderInvoiceFormData {
    return {
      purchaseOrderId: purchaseOrder.id,
      additionalInfo: purchaseOrder.additionalInfo?.invoiceNote?.body ?? "",
      invoiceDueDate: purchaseOrder.invoiceDueDate ?? "",
      invoiceFiles: purchaseOrderInvoiceFiles,
      isProforma: purchaseOrder.isProForma ?? false,
      invoiceReferenceNumber: purchaseOrder.invoiceReferenceNumber ?? ""
    };
  }

  public static updatePurchaseOrderInvoiceRequestBodyFromFormData(
    updatePurchaseOrderInvoiceFormData: UpdatePurchaseOrderInvoiceFormData,
    initialUpdatePurchaseOrderInvoiceFormData?: UpdatePurchaseOrderInvoiceFormData
  ): PatchPurchaseOrderInvoiceRequestBody {
    const { invoiceDueDate, additionalInfo, invoiceReferenceNumber } = updatePurchaseOrderInvoiceFormData;
    const { additionalInfo: initialAdditionalInfo } = initialUpdatePurchaseOrderInvoiceFormData ?? {};

    const normalisedInvoiceDueDate = invoiceDueDate;
    const normalisedInvoiceNoteBody = !initialAdditionalInfo && !additionalInfo ? undefined : additionalInfo || null;
    const normalisedInvoiceReferenceNumber = invoiceReferenceNumber.trim() || null;

    return {
      invoiceDueDate: normalisedInvoiceDueDate,
      invoiceNoteBody: normalisedInvoiceNoteBody,
      invoiceReferenceNumber: normalisedInvoiceReferenceNumber
    };
  }
}
